import axios, {AxiosResponse} from 'axios';

export default class ContactsClient {
  static getOrganisationContacts(organisationId: string): Promise<AxiosResponse> {
    const requestOptions: object = {
      method: 'GET',
      url: `${process.env.API_URL}/organisation/${organisationId}/contact-person`,
    };

    return axios(requestOptions);
  }
}
